module.exports = __webpack_public_path__ + "media/images/6OJsTNT01-516eec3afb9d6861f176d3a2fadb3618.svg";